/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { func } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import RecipientListContainer from './RecipientListContainer';
import fetchRecipientBookListWithOccasions from '../../../../../../../../apis/account-apis/RecipientBook-apis/fetchRecipientBookListWithOccasions';
import mbpLogger from 'mbp-logger';
import { sortRecipients } from '../../../../AddressBook/RecipientBook/Common/Helpers/Helpers';
import Spinner from '../../../../../assets/svg/Spinner';
const useStyles = makeStyles(() => ({
    loaderContainer: {
        justifyContent: 'center',
        '& svg': {
            fontSize: '4rem'
        }
    }
}));
const FloraVerseRecipients = ({ setIsRecipientListVisible, setOtherOption, handleOptionChange}) => {
    const classes = useStyles();
    const userProfile = useSelector((state) => state.account.userProfile || state.member.profile);
    const { status, error, data , isLoading} = useQuery(
        ["recipientBookList", userProfile?.ContactId],
        fetchRecipientBookListWithOccasions,
        {
            refetchOnWindowFocus: false,
            retry: false,
        },
    );
    if (isLoading) {
        return (<div className={classes.loaderContainer}>
            <Spinner/>
        </div>)

    }
    if (status ==='success') {
        const { addressBookResponse: { contactId }, addressBookResponse } = data.data;
        const filteredAddressList = addressBookResponse.addressList.filter(entry => entry.relationship);
        const sortedRecipientBookListRes = {
            addressBookResponse: {
                addressList: sortRecipients('asc', { addressList: filteredAddressList }),
                totalEntries: filteredAddressList.length,
                contactId,
                sortOption: 'asc'
            },
        };
           return (
            <RecipientListContainer
                    recipientData={sortedRecipientBookListRes}
                    recipientBookListResError={''}
                    setIsRecipientListVisible={setIsRecipientListVisible}
                    setOtherOption={setOtherOption}
                    handleOptionChange={handleOptionChange}
                />)
    }
    if (status === 'error') {
        setIsRecipientListVisible(false);
        mbpLogger.logError({
            function: 'getRecipientBookList',
            appName: process.env.npm_package_name,
            module: 'FloraVerseRecipients',
            message: `Error While calling recipient book for contactId ${userProfile?.ContactId}`,
            error,
        });
        return null;
    }
    return null;
};

FloraVerseRecipients.propTypes = {
    handleOptionChange: func.isRequired,
    setIsRecipientListVisible: func,
    setOtherOption: func,
};
export default FloraVerseRecipients;
